import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { advanceParamCheck } from "../../utils";

export interface ChooseVideoOption extends Partial<GeneralInvokeOption> {
  sourceType?: Array<String>;
  camera?: String;
  invalidParamObj?: '';
}

// 录像或上传
export function chooseVideo(option: ChooseVideoOption) {
  const checkOptions = {
    sourceType: {
      optional: true, // 可选参数
      checkSubEleType: true, // 检查子项类型
      range: ['album', 'camera'] // 值范围
    },
    camera: {
      optional: true, // 可选参数
      range: ['back', 'front'] // 值范围
    }
  };
  if (advanceParamCheck(APINames.Native.CHOOSE_VIDEO, option, { sourceType: [''], camera: '' }, checkOptions)) {
    const finalOption = Object.assign(
      {
        sourceType: ['album', 'camera'],
        camera: 'back'
      },
      option
    );
    return MacleJSBridge.beforeInvoke(
      APINames.Native.CHOOSE_VIDEO,
      finalOption
    );
  }
  return option.invalidParamObj;
}
